export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'long', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "Iniciar sessão",
    "login.form.hint.user": "Iniciar sessão",
    "login.form.hint.password": "Palavra-passe",
    "login.form.checkbox.remember-me": "Memorizar-me",
    "login.form.button.sign-in": "Iniciar sessão",
    "login.form.message.invalid-user-credentials": "O início de sessão ou palavra-passe está incorreto",
    "login.form.message.user-required": "Introduza um início de sessão",
    "login.form.message.password-required": "Introduza uma palavra-passe",
    "login.form.button.forgot-password": "Esqueceu-se da palavra-passe?",
    "error.root-admin-login.title": "Erro 403 – operação proibida",
    "error.root-admin-login.message": "Tem sessão iniciada como Administrador só de leitura. Para aceder à consola do Web Recovery, inicie sessão como utilizador ou administrador de um inquilino de cliente"
};
